import React from 'react';
import Home from './containers/Home';

export default function Boards() {
    
    return (
        <Home />
    )
}
